import React, { Component } from 'react'
import { connect } from 'react-redux';
let RealLibraryView = null;

class LibraryView extends Component {
  	constructor(props) {
    	super(props);
    	this.state = { isReady: RealLibraryView !== null };
  	}

  	componentDidMount() {
  		const {isAuthenticated} = this.props
  		
  		if(!isAuthenticated) return
  		this.load()
  	}
  	
	componentWillReceiveProps({isAuthenticated}) {
		if(isAuthenticated && !RealLibraryView) this.load()
	}

  	load() {
    	require.ensure('./auth', () => {
      		RealLibraryView = require('./auth').RealLibraryView;
      		if (!this.hasUnmounted) {
        		this.setState({ isReady: true });
      		}
    	});
  	}

  	componentWillUnmount() {
    	this.hasUnmounted = true;
  	}

  	render() {
  		return this.state.isReady ? <RealLibraryView/> : null;
  	}
}

export default connect(state => ({isAuthenticated: state.auth.isAuthenticated}))(LibraryView);



// WEBPACK FOOTER //
// ./src/components/auth/LibraryView.js